import * as feedbackApi from '../api/feedback'
import { handleApiError } from './api-errors'
import { showSuccess } from './alerts'

export const CREATE_FEEDBACK = 'CREATE_FEEDBACK'
export const DELETE_FEEDBACK = 'DELETE_FEEDBACK'

export const createFeedback = (idea_id, feedback_text, isPublic=false) => (dispatch) => {
    feedbackApi
        .putObj(idea_id, {
            text: feedback_text,
            public: isPublic
        })
        .then((res) => {
            dispatch({
                type: CREATE_FEEDBACK,
                payload: res,
            })
            dispatch(showSuccess('Feedback added!'))
        })
        .catch((err) => dispatch(handleApiError(err)))
}

export const deleteFeedback = (idea_id, feedback_id) => (dispatch) => {
    feedbackApi
        .deleteObj(idea_id, feedback_id)
        .then((res) => {
            dispatch({
                type: DELETE_FEEDBACK,
                payload: res,
            })
            dispatch(showSuccess('Feedback deleted!'))
        })
        .catch((err) => dispatch(handleApiError(err)))
}
